module.exports = __webpack_public_path__ + "img/debian-bleu@2x.5950e687.png";